import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import {
  CreateMemberRequest,
  DeleteMemberRequest,
  DownloadMemberExcelRequest,
  DownloadMemberExcelResponse,
  UpdateMemberRequest,
  ViewAllMembersRequest,
  ViewMemberProfileRequest,
  ViewMemberRequest,
  ViewTribeMembersRequest
} from './member.types';

import {
  requestCreateMember,
  requestDeleteMember,
  requestDownloadMemberExcel,
  requestUpdateMember,
  requestViewAllMembers,
  requestViewMember,
  requestViewMemberProfile,
  requestViewTribeMembers
} from './member.actions';

export const useMemberApi = () => {
  const dispatch = useDispatch();

  const createMember = useCallback(
    (requestData: CreateMemberRequest, onSuccess?: () => void) => {
      dispatch(requestCreateMember({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const viewAllMembers = useCallback(
    (requestData: ViewAllMembersRequest) => {
      dispatch(requestViewAllMembers({ requestData }));
    },
    [dispatch]
  );

  const updateMember = useCallback(
    (requestData: UpdateMemberRequest, onSuccess?: () => void) => {
      dispatch(requestUpdateMember({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const deleteMember = useCallback(
    (requestData: DeleteMemberRequest, onSuccess?: () => void) => {
      dispatch(requestDeleteMember({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const downloadMemberExcel = useCallback(
    (requestData: DownloadMemberExcelRequest, onSuccess?: (data: DownloadMemberExcelResponse) => void) => {
      dispatch(requestDownloadMemberExcel({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const viewTribeMembers = useCallback(
    (requestData: ViewTribeMembersRequest) => {
      dispatch(requestViewTribeMembers({ requestData }));
    },
    [dispatch]
  );

  const viewMember = useCallback(
    (requestData: ViewMemberRequest) => {
      dispatch(requestViewMember({ requestData }));
    },
    [dispatch]
  );

  const viewMemberProfile = useCallback(
    (requestData: ViewMemberProfileRequest) => {
      dispatch(requestViewMemberProfile({ requestData }));
    },
    [dispatch]
  );

  return {
    createMember,
    viewAllMembers,
    updateMember,
    deleteMember,
    downloadMemberExcel,
    viewTribeMembers,
    viewMember,
    viewMemberProfile
  };
};
